"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _envSuffix = _interopRequireDefault(require("./lib/envSuffix"));

var _MD = _interopRequireDefault(require("./lib/MD5"));

var _Constants = require("./Constants");

var _UIAvatarDisplay = _interopRequireDefault(require("./UIAvatarDisplay/UIAvatarDisplay"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var UIUnauthedHubSpotUserAvatar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIUnauthedHubSpotUserAvatar, _Component);

  function UIUnauthedHubSpotUserAvatar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIUnauthedHubSpotUserAvatar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIUnauthedHubSpotUserAvatar).call(this, props));
    _this.state = {
      shouldRender: false
    };
    return _this;
  }

  (0, _createClass2.default)(UIUnauthedHubSpotUserAvatar, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      var imageURI = this.getHubSettingsUrl();
      var that = this;

      if (this.props._noDefaultSrc) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', imageURI);

        xhr.onerror = function () {
          return _this2.setState({
            shouldRender: false
          });
        };

        xhr.onload = function () {
          var img = new Image();
          var response = xhr.responseText;
          var binary = '';

          for (var i = 0; i < response.length; i++) {
            binary += String.fromCharCode(response.charCodeAt(i) & 0xff);
          }

          img.src = "data:image/jpeg;base64" + btoa(binary);
          return that.setState({
            shouldRender: img.src
          });
        };

        xhr.overrideMimeType('text/plain; charset=x-user-defined');
        xhr.send();
      }

      return this.setState({
        shouldRender: imageURI
      });
    }
  }, {
    key: "getEmailHash",
    value: function getEmailHash() {
      var _this$props = this.props,
          email = _this$props.email,
          hubSpotUserEmail = _this$props.hubSpotUserEmail;
      return (0, _MD.default)((hubSpotUserEmail || email).toLowerCase());
    }
  }, {
    key: "getHubSettingsUrl",
    value: function getHubSettingsUrl() {
      var _this$props2 = this.props,
          hubSpotUserEmail = _this$props2.hubSpotUserEmail,
          size = _this$props2.size;
      var email = hubSpotUserEmail || this.props.email;

      if (typeof email === 'undefined') {
        return _Constants.DEFAULT_AVATAR_MAPPINGS.hubSpotUserEmail;
      }

      var sizePx = size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[size] : _Constants.AVATAR_SIZES.xl;
      var doubleDimensionForRetina = sizePx * _Constants.RETINA_MULTIPLIER;
      return "https://app.hubspot" + (0, _envSuffix.default)() + ".com/hubsettings/v1/avatar/hash/" + this.getEmailHash() + "/" + doubleDimensionForRetina;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          email = _this$props3.email,
          hubSpotUserEmail = _this$props3.hubSpotUserEmail,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["email", "hubSpotUserEmail"]);
      return this.state.shouldRender && _react.default.createElement(_UIAvatarDisplay.default, (0, _extends2.default)({}, rest, {
        hubSpotUserEmail: hubSpotUserEmail || email,
        src: this.state.shouldRender,
        displayName: hubSpotUserEmail || email
      }));
    }
  }]);
  return UIUnauthedHubSpotUserAvatar;
}(_react.Component);

var PropTypeEmail = function PropTypeEmail(props, propName, componentName) {
  if (propName === 'email') {
    _devLogger.default.warn({
      message: "Use hubSpotUserEmail instead of email in " + componentName
    });
  }

  if (!props.email && !props.hubSpotUserEmail) {
    return new Error(componentName + " requires a hubSpotUserEmail");
  }

  return null;
};

UIUnauthedHubSpotUserAvatar.propTypes = {
  _noDefaultSrc: _propTypes.default.bool,
  email: PropTypeEmail,
  hubSpotUserEmail: PropTypeEmail,
  size: _UIAvatarDisplay.default.propTypes.size
};
UIUnauthedHubSpotUserAvatar.defaultProps = {
  size: 'sm'
};
var _default = UIUnauthedHubSpotUserAvatar;
exports.default = _default;
module.exports = exports.default;